var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapsuleAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2314 21.8331C20.9625 21.119 22.5668 18.3177 21.8146 15.5764L20.4526 10.6128L10.5623 13.1989L11.9243 18.1625C12.6765 20.9039 15.5003 22.5472 18.2314 21.8331Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42359 2.18542C5.68226 1.43322 2.88105 3.03746 2.16691 5.76859C1.45277 8.49971 3.09614 11.3235 5.83747 12.0757L10.8011 13.4377L13.3872 3.54741L8.42359 2.18542Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsuleAlt1);
export default __webpack_public_path__ + "static/media/capsule-alt-1.a6fc1bc41684b46f3e40fd1b3a3cce98.svg";
export { ForwardRef as ReactComponent };